import { ConnectWithUsActions } from "./action";
import { takeEvery, call, all, put } from "redux-saga/effects";
import { API_URL } from "../../utils/Constant";
import axios from "axios";

export const ConnectWithUsSagas = function* () {
  yield all([
    takeEvery(ConnectWithUsActions.GET_CONNEC_WITH_US, getConnectWithUs),
    takeEvery(ConnectWithUsActions.CONTACT_US_FORM_SUBMISSION, ContactUsFormSubmission),
    takeEvery(
    ConnectWithUsActions.GET_CONNECT_WITH_US_GFORM,
    getConnectWithUsGform
  ),
  ]);
};

const getConnectWithUs = function* (data) {
  try {
    const result = yield call(() => axios.get(`${API_URL}/connect_with_us`));

    yield put({
      type: ConnectWithUsActions.SET_CONNEC_WITH_US,
      payload: result.data,
    });
  } catch (error) {
    console.error("Error", error);
  }
};

const ContactUsFormSubmission = function* (data) {
  const { payload } = data
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/connect`, payload)
    )
    if (result?.status === 200) {
      yield put({
        type: ConnectWithUsActions.SET_CONTACT_US_RESPONSE,
        payload: result?.data
      })
    }
   

  } catch (err) {
    console.error("Error", err)
  }
}

const getConnectWithUsGform = function* () {
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/connect_with_us_gform`)
    );

    const editUrl = result?.data?.data?.[0];
    const viewFormUrl = editUrl?.replace("/edit", "/viewform");

    yield put({
      type: ConnectWithUsActions.SET_CONNECT_WITH_US_GFORM,
      payload: viewFormUrl,
    });
  } catch (error) {
    console.error("Error fetching GForm", error);
  }
};
